import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { createAppRouter } from './router/routes'
import './styles/tokens.css'
import './styles/reset.css'
// Material Symbols (rounded) variable font — registers @font-face once for
// the whole app so <Icon /> can render any MD3 symbol via ligature names.
import 'react-material-symbols/rounded'
import { registerChartDefaults } from './lib/chart-defaults'
import { OrgConfigProvider } from './lib/org-config-context'

registerChartDefaults()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
})

const router = createAppRouter()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found in document')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <OrgConfigProvider>
        <RouterProvider router={router} />
      </OrgConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
